import { gql } from '@apollo/client';

export const CREATE_USER_PATH = gql`
  mutation UserPath($input: UserPathCreateInput!) {
    createUserPath(input: $input) {
      _id
      status
    }
  }
`;

export const UPDATE_USER_PATH = gql`
  mutation updateUserPath($input: UserPathUpdateInput!) {
    updateUserPath(input: $input) {
      _id
      status
    }
  }
`;

export const ADD_EXTRA_TODAY_SESSION = gql`
  mutation addExtraTodaySession($userPathId: String!) {
    addExtraTodaySession(userPathId: $userPathId) {
      _id
    }
  }
`;

